import { Component, OnInit, ViewChild } from '@angular/core';
import { RootReducerState } from '../store';
import { Store } from '@ngrx/store';
import { AuthenticationService } from '../core/services/auth.service';
import { TokenStorageService } from '../core/services/token-storage.service';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Attachment } from '../core/models/attachment.models';
import { DownloadwindowComponent } from '../shared/downloadwindow/downloadwindow.component';
import { GlobalComponent } from '../global-component';
import { EventService } from '../core/services/event.service';
import { ChatUnreadService } from '../core/services/chat-unread.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { User } from '../core/models/user.models';
import { environment } from '../../environments/environment';

@UntilDestroy()
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {

  @ViewChild('downloadfiles') private downloadfilescomponent!: DownloadwindowComponent;

  layoutType!: string;
  currentUser! : User;
  accessbot = false;

  constructor(private store: Store<RootReducerState>, private tokenService: TokenStorageService,
    private authenticationService: AuthenticationService, private afs: AngularFirestore,
    private eventService: EventService, private chatUnreadService: ChatUnreadService) { }

  ngOnInit(): void {
    this.currentUser = this.tokenService.getUser();
    this.accessbot = environment.accessbot;

    this.store.select('layout').pipe(untilDestroyed(this)).subscribe((data) => {
      let mode = this.tokenService.getLayoutMode();
      this.layoutType = data.LAYOUT;
      document.documentElement.setAttribute('data-layout', data.LAYOUT);
      document.documentElement.setAttribute('data-bs-theme', mode);
      document.documentElement.setAttribute('data-theme', data.LAYOUT_THEME);
      document.documentElement.setAttribute('data-theme-colors', data.LAYOUT_THEME_COLOR);
      document.documentElement.setAttribute('data-layout-width', data.LAYOUT_WIDTH);
      document.documentElement.setAttribute('data-layout-position', data.LAYOUT_POSITION);
      document.documentElement.setAttribute('data-topbar', data.TOPBAR);
      data.LAYOUT == "vertical" || data.LAYOUT == "twocolumn" ? document.documentElement.setAttribute('data-sidebar', data.SIDEBAR_COLOR) : '';
      data.LAYOUT == "vertical" || data.LAYOUT == "twocolumn" ? document.documentElement.setAttribute('data-sidebar-size', data.SIDEBAR_SIZE) : '';
      data.LAYOUT == "vertical" || data.LAYOUT == "twocolumn" ? document.documentElement.setAttribute('data-sidebar-image', data.SIDEBAR_IMAGE) : '';
      data.LAYOUT == "vertical" || data.LAYOUT == "twocolumn" ? document.documentElement.setAttribute('data-layout-style', data.SIDEBAR_VIEW) : '';
      document.documentElement.setAttribute('data-preloader', data.DATA_PRELOADER)
      document.documentElement.setAttribute('data-sidebar-visibility', data.SIDEBAR_VISIBILITY);
    });

    this.afs.collection("hardlogout").doc(this.currentUser.guid).valueChanges().subscribe(async (val: any) => {
      if (val && val.hardlogout) {
        await this.afs.collection("hardlogout").doc(this.currentUser.guid).update({ hardlogout: false });
        this.authenticationService.logout();
        location.reload();
      }
    });

    this.eventService.subscribe(GlobalComponent.broadcasts.opendownloadwindow, value => {
      this.downloadfile(value);
    });

    this.chatUnreadService.start();

    navigator.serviceWorker.register('firebase-messaging-sw.js');
  }

  closeDownloadWindow(eventData: { eventname: string }) {
    document.getElementById('downloadfiles-window')?.classList.add('d-none');
  }

  downloadfile(file: Attachment) {
    document.getElementById('downloadfiles-window')?.classList.remove('d-none');
    this.downloadfilescomponent.addfilestoqueue(file);
  }
}
